export class Api {
  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  async request(path, body) {
    const options = {
      headers: this.headers,
      method: 'POST',
      body: JSON.stringify(body)
    }
    const response = await fetch(`api/v1/auth/${path}`, options)
    if (response.ok) {
      return await response.json()
    } else {
      throw await response.json()
    }
  }

  async obtainToken(email, password) {
    const body = {email, password}
    return this.request('obtain-token', body)
  }

  async refreshToken(refresh) {
    const body = {refresh}
    return this.request('refresh-token', body)
  }

  async verifyToken(token) {
    const body = {token}
    try {
      return this.request('verify-token', body)
    } catch(e) {
      throw e
    }
  }

  async resetPassword(email, recaptcha_response) {
    const body = {email, recaptcha_response}
    try {
      return this.request('password-recovery', body)
    } catch(e) {
      throw e
    }
  }

  async resetPasswordConfirm(credentials) {
    try {
      return this.request('password-recovery-check', credentials)
    } catch(e) {
      throw e
    }
  }
}
